import firebase from "../Utils/Firebase";

export default class Salon {
  uid = null;
  fullName = null;
  email = null;
  phoneNumber = null;

  shopName = null;
  shopNumber = null;
  shopAddress = null;
  longitude = 0;
  latitude = 0;
  pictureURL = null;
  pictures = null;
  pictureCaptions = null;
  videoURL = null;
  subscribed = false;
  display = false;
  wantVoucher = false;
  websiteUrl=null;
  isTrimItBarber = false;
  reviews = null;
  openingTimes = null;
  closingTimes = null;
  package = null;
  transactionId = null;
  transactionDate = null;
  creationDate = null;
  amenities = null;
  established = null;
  nearbyTitles = null;
  nearbyDistance = null;
  nearbyService = null;
  nearbyImage = null;
  serviceTitles = null;
  servicePrices = null;
  serviceDurations = null;
  teamPictures = null;
  teamNames = null;
  teamBios = null;
  paymentMethod = null;
  ethnicities = null;
  subscriptionType = null;

  mondayOpen = 0;
  mondayClose = 0;
  tuesdayOpen = 0;
  tuesdayClose = 0;
  wednesdayOpen = 0;
  wednesdayClose = 0;
  thursdayOpen = 0;
  thursdayClose = 0;
  fridayOpen = 0;
  fridayClose = 0;
  saturdayOpen = 0;
  saturdayClose = 0;
  sundayOpen = 0;
  sundayClose = 0;

  constructor(dictionary) {
    this.uid = dictionary.uid;

    if (dictionary.fullName) {
      this.fullName = dictionary.fullName;
    }

    if (dictionary.email) {
      this.email = dictionary.email;
    }

    if (dictionary.subscriptionType) {
      this.subscriptionType = dictionary.subscriptionType;
    }

    if (dictionary.phoneNumber) {
      this.phoneNumber = dictionary.phoneNumber;
    }

    if (dictionary.shopName) {
      this.shopName = dictionary.shopName;
    }

    if (dictionary.shopNumber) {
      this.shopNumber = dictionary.shopNumber;
    }

    if (dictionary.paymentMethod) {
      this.paymentMethod = dictionary.paymentMethod;
    } else {
      this.paymentMethod = "Not Set!";
    }

    if (dictionary.shopAddress) {
      this.shopAddress = dictionary.shopAddress;
    }

    if (dictionary.established) {
      this.established = dictionary.established;
    }

    if (dictionary.longitude) {
      this.longitude = dictionary.longitude;
    }

    if (dictionary.latitude) {
      this.latitude = dictionary.latitude;
    }

    if (dictionary.pictureURL) {
      this.pictureURL = dictionary.pictureURL;
    }

    if (dictionary.videoURL) {
      this.videoURL = dictionary.videoURL;
    }

    if (dictionary.ethnicities) {
      this.ethnicities = dictionary.ethnicities.join();
    }

    if (dictionary.teamNames) {
      this.teamNames = dictionary.teamNames.join();
    }

    if (dictionary.teamPictures) {
      this.teamPictures = dictionary.teamPictures.join();
    }

    if (dictionary.teamBios) {
      this.teamBios = dictionary.teamBios.join("@");
    }

    if (dictionary.serviceTitles) {
      this.serviceTitles = dictionary.serviceTitles.join();
    }

    if (dictionary.servicePrices) {
      this.servicePrices = dictionary.servicePrices.join();
    }

    if (dictionary.serviceDurations) {
      this.serviceDurations = dictionary.serviceDurations.join();
    }

    if (dictionary.nearbyTitles) {
      this.nearbyTitles = dictionary.nearbyTitles.join();
    }

    if (dictionary.nearbyService) {
      this.nearbyService = dictionary.nearbyService.join();
    }

    if (dictionary.nearbyDistance) {
      this.nearbyDistance = dictionary.nearbyDistance.join();
    }

    if (dictionary.nearbyImage) {
      this.nearbyImage = dictionary.nearbyImage;
    }

    if (dictionary.pictures) {
      this.pictures = dictionary.pictures.join();
    }

    if (dictionary.pictureCaptions) {
      this.pictureCaptions = dictionary.pictureCaptions.join();
    }

    if (dictionary.amenities) {
      this.amenities = dictionary.amenities.join();
    }

    if (dictionary.subscribed) {
      this.subscribed = dictionary.subscribed;
    }

    if (dictionary.reviews) {
      this.reviews = dictionary.reviews;
    }

    if (dictionary.openingTimes) {
      this.openingTimes = dictionary.openingTimes;
    }

    if (dictionary.closingTimes) {
      this.closingTimes = dictionary.closingTimes;
    }

    if (dictionary.package) {
      this.package = dictionary.package;
    }

    if (dictionary.transactionId) {
      this.transactionId = dictionary.transactionId;
    }

    if (dictionary.transactionDate) {
      this.transactionDate = dictionary.transactionDate;
    }

    if (dictionary.display) {
      this.display = dictionary.display;
    } else {
      this.display = false;
    }

    if (dictionary.wantVoucher) {
      this.wantVoucher = dictionary.wantVoucher;
    } else {
      this.wantVoucher = false
    }

    if (dictionary.isTrimItBarber) {
      this.isTrimItBarber = dictionary.isTrimItBarber;
    } else {
      this.isTrimItBarber = false
    }

    if (dictionary.websiteUrl) {
      this.websiteUrl = dictionary.websiteUrl;
    }

    if (dictionary.creationDate) {
      // console.log(dictionary.creation_date);
      if (typeof dictionary.creationDate === "object") {
        this.creationDate = dictionary.creationDate.toDate();
      } else {
        this.creationDate = new Date(dictionary.creationDate);
      }
    }

    if (dictionary.openingTimes) {
      this.mondayOpen = dictionary.openingTimes.monday;
      this.tuesdayOpen = dictionary.openingTimes.tuesday;
      this.wednesdayOpen = dictionary.openingTimes.wednesday;
      this.thursdayOpen = dictionary.openingTimes.thursday;
      this.fridayOpen = dictionary.openingTimes.friday;
      this.saturdayOpen = dictionary.openingTimes.saturday;
      this.sundayOpen = dictionary.openingTimes.sunday;
    }

    if (dictionary.closingTimes) {
      this.mondayClose = dictionary.closingTimes.monday;
      this.tuesdayClose = dictionary.closingTimes.tuesday;
      this.wednesdayClose = dictionary.closingTimes.wednesday;
      this.thursdayClose = dictionary.closingTimes.thursday;
      this.fridayClose = dictionary.closingTimes.friday;
      this.saturdayClose = dictionary.closingTimes.saturday;
      this.sundayClose = dictionary.closingTimes.sunday;
    }
  }

  instanceMethod() {
    return true;
  }
}
